import { TreeNode } from './hydratedTypes.greenhouse';

export function linkChildren<T extends TreeNode>(store: Map<number, T>) {
  const items = Array.from(store.values());
  items.forEach(item => {
    // look up the parent by id
    if (typeof item.parent_id === 'number') {
      item.parent = store.get(item.parent_id);
    }

    // link the parent to the child if it exists
    if (item.parent) {
      item.parent.children.add(item as any);
    }

    // for each child id
    item.child_ids.forEach(childId => {
      // look up child by id
      const child = store.get(childId);

      // child not found or parent has already be assigned, skip
      if (!child || child.parent) return;

      // link this item as the parent of the child
      child.parent = item;

      // add the item to children
      item.children.add(child as any);
    });
  });

  // add the jobs from children
  // must be done after children relationships have been established
  items.forEach(item => item.children.forEach((child: TreeNode) => child.jobs.forEach(job => item.jobs.add(job))));
}

export function getOrCreate<T>(store: Map<number, T>, key: number, producer: () => T) {
  const value = store.get(key) || producer();
  store.set(key, value);
  return value;
}
